import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ContactUsData } from '../../models/contact-us-data';
import { BaseService } from '../base/base.service';

@Injectable()
export class EmailService extends BaseService {
    private apiUrl = environment.apiUrl + '/email/';

    constructor(private http: HttpClient) {
        super();
    }

    public sendContactUsEmail(contactUsData: ContactUsData): Observable<any> {
        this.setHttpOptions();
        return this.http.post<any>(this.apiUrl + 'ContactUs', JSON.stringify(contactUsData), this.httpOptions)
            .pipe(catchError(this.handleError));
    }
}
